export const MONTSERRAT = "'Montserrat', sans-serif";
export const PROXIMA_NOVA = "'Proxima Nova', sans-serif";
export const ROBOTO = "'Roboto', sans-serif";
